module.exports = __webpack_public_path__ + "img/bsfq-mobile-1.76d725eb.svg";